import React from 'react'
import { Badge } from '../index'
import * as colors from '../../assets/js/colors'

export default function PrestacaoContasStatus({ status }) {
  // Render
  if (status === 'Pendente') {
    return <Badge color={colors.vinho}>Pendente</Badge>
  } else if (status === 'Em Validação') {
    return <Badge color={colors.laranja}>Em Validação</Badge>
  } else if (status === 'Finalizada') {
    return <Badge color={colors.verde}>Finalizada</Badge>
  }
}
